<template>
  <div class="home-box">
    <top-head></top-head>
    <video-part ref="videoPartRef"></video-part>
    <div class="game-box">
      <title-bar title="Betta Games"></title-bar>
      <div class="game-swiper">
        <div class="slider-box">
          <slick ref="slick" :options="slickOptions" @afterChange="slide">
            <img src="../../../static/images/home/game1.jpg">
            <img src="../../../static/images/home/game2.jpg">
            <img src="../../../static/images/home/game3.jpg">
            <img src="../../../static/images/home/game4.jpg">
            <img src="../../../static/images/home/game5.jpg">
            <img src="../../../static/images/home/game6.jpg">
            <img src="../../../static/images/home/game7.jpg">
            <img src="../../../static/images/home/game8.jpg">
            <img src="../../../static/images/home/game9.jpg">
            <img src="../../../static/images/home/game10.jpg">
          </slick>
        </div>
        <div class="game-scroll">
          <div class="game-scroll-item" @click="scrollItemClick(item)"
            :class="item==activeScroll?'game-scroll-active':''" v-for="item in 10" :key="item"></div>
        </div>
        <div class="game-font">
          <div class="game-font-title">{{gameTitle}}</div>
          <div class="game-font-content">
            {{gameFont}}
          </div>
        </div>
      </div>
    </div>
    <div class="join-us">
      <img src="../../../static/images/home/joinus.jpg" />
      <div class="join-us-content">
        <div class="join-us-title">
          Career
        </div>
        <div class="join-us-card">
          <a href="http://fotoable.hirede.com/CareerSite/Index" target="_blank">
            <div class="join-us-card-left" @mouseover="szmouseOver" @mouseleave="szmouseLeave">
              <div class="join-us-card-title" v-show="szShow">Social Recruitment</div>
              <div class="join-us-card-title2" v-show="!szShow">
                <div class="join-us-card-title2-1">Social Recruitment</div>
                <div class="join-us-card-font">
                  社会招聘
                </div>
              </div>
            </div>
          </a>
          <a href="http://fotoable.hirede.com/CareerSite/CampusRecruit" target="_blank">
            <div class="join-us-card-right" @mouseover="xzmouseOver" @mouseleave="xzmouseLeave">
              <div class="join-us-card-title" v-show="xzShow">Campus Recruitment</div>
              <div class="join-us-card-title2" v-show="!xzShow">
                <div class="join-us-card-title2-1">Campus Recruitment</div>
                <div class="join-us-card-font">
                  校园招聘
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <home-foot></home-foot>
  </div>
</template>
<script>
  import topHead from '../parts/headPart';
  import videoPart from '../parts/home/videoPart.vue';
  import homeFoot from '../parts/homeFoot.vue'
  import Slick from 'vue-slick';
  import TitleBar from '../common/title-bar.vue';
  import 'slick-carousel/slick/slick.css';
  export default {
    name: 'homePage',
    components: {
      topHead,
      videoPart,
      homeFoot,
      Slick,
      TitleBar
    },
    data() {
      return {
        slickOptions: {
          centerMode: true, //中心模式
          autoplay: true, //自动播放
          arrows: false, //不显示箭头
          draggable: false, //不可拖动
          focusOnSelect: true, //单击幻灯片
          variableWidth: true, //允许不同宽度幻灯片
          slidesToShow: 5
        },
        gameTitle: '',
        gameFont: '',
        szShow: true,
        xzShow: true,
        activeScroll: 1,
        gameWord: [{
          title: 'Meeerge',
          content: 'A divine artifact has been sealed from a dangerous spell. Heroes set forth on a journey with their tribe to discover mystical lands and recover the divine artifact. The only chance they fulfill the task is your merge magic to MATCH EVERYTHING! '
        }, {
          title: 'Buddies',
          content: 'Word Buddies is a free and fun crossword game. It will exercise your brain and expand your vocabulary. It‘s definitely the most interesting word game for you to kill time and relax.'
        }, {
          title: 'Crossy',
          content: 'Word Crossy is a relaxing Word game where you connect letters together to form words on a crossword-style board. Learn while you play! With over 12，000 levels and thousands of words ranging from simple to complex, Word Crossy will help you become a true Word Master. '
        }, {
          title: 'Crush',
          content: 'Are you looking for a new word game? Do you want to immerse yourself into a challenging intellectual competition? Come and play the word game and embark on a new trip! You only need to connect and match the letters in the word puzzles. '
        }, {
          title: 'Dragon Farm Adventure',
          content: 'Welcome to the ultimate experience of farming and adventure! Go on a fantastic adventure with lovely dragons! Build a farm, explore mysterious islands, discover the secrets of dragons, and complete various challenging missions! Come and join this mysterious and exciting adventure!'
        }, {
          title: 'Solitaire Home Design',
          content: 'Lori and Eddie embark on a journey of transforming and renovating an entire island into a beautiful paradise. At the same time, you’ll enjoy solitaire games to exercise your brain and become smarter.'
        }, {
          title: 'Mergical',
          content: 'Welcome to the fantastic Mergical Island! This is a mysterious land full of magical fantasies. Here, you can explore the lost world, also to build and design the island based on your preference! A perfect merge and building game!'
        }, {
          title: 'Tank Hero',
          content: 'The tank war has begun, the enemies are gathered for an attack. All you can do now, is to use your special ability to defend against waves of enemy tanks, then find the opportunity for a counter attack. Remember, once you die, you will restart from the beginning.'
        }, {
          title: 'Townest',
          content: "Welcome to Townest: Alfred’s Adventure! Check out this magical town full of mysteries. Help Alfred restore his hometown, renovate, and pass levels to find clues on his missing grandmother.  "
        }, {
          title: 'Word Villas',
          content: 'Design your dream home with Word Villas! This game is the perfect combination of Word Puzzles and Home Decorating. Start your adventure by helping Rachel renovate her old house and start a new life!'
        }]
      }
    },
    mounted() {
      this.gameTitle = this.gameWord[0].title
      this.gameFont = this.gameWord[0].content
      window.addEventListener('scroll', this.getScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.getScroll);
    },
    methods: {
      //监听滚动
      getScroll() {
        let indexNumTop = document.getElementsByClassName('game-box')[0].getBoundingClientRect().top
        if (indexNumTop < 0) {
          this.$refs.videoPartRef.videoSuspend()
        }
      },
      scrollItemClick(i) {
        this.$refs.slick.goTo(i - 1);
      },
      slide(event, slick, currentSlide) {
        this.activeScroll = currentSlide + 1
        this.gameTitle = this.gameWord[currentSlide].title
        this.gameFont = this.gameWord[currentSlide].content
      },
      szmouseOver() {
        this.szShow = false
      },
      szmouseLeave() {
        this.szShow = true
      },
      xzmouseOver() {
        this.xzShow = false
      },
      xzmouseLeave() {
        this.xzShow = true
      }
    }
  }
</script>

<style lang="less">
  img {
    -webkit-user-drag: none;
  }

  .home-box {

    .game-swiper {
      height: 519px;
      background-color: #000C36;
      padding-top: 55px;

      .slider-box {
        height: 280px;

        img {
          vertical-align: middle;
        }

        .slick-slide {
          width: 360px;
          margin: 78px 10px 0 10px;
        }

        .slick-active {
          img {
            transform: translate(-70px, 0);
          }
        }

        .slick-center {
          transform: scale(1.39);
          margin-top: 39px;

          img {
            transform: translate(0);
          }
        }

        .slick-center+.slick-active {
          transform: translate(140px, 0);
        }

        .slick-center+.slick-active+.slick-active {
          transform: translate(140px, 0);
        }
      }

      .game-scroll {
        width: 500px;
        height: 4px;
        margin: 0 auto;
        margin-top: 30px;
        position: relative;

        .game-scroll-item {
          width: 50px;
          height: 4px;
          background-color: rgba(255, 255, 255, 0.4);
          display: inline-block;
          cursor: pointer;

          &:hover {
            background-color: #fff;
          }
        }

        .game-scroll-active {
          background-color: #fff;
        }
      }

      .game-font {
        color: #fff;

        .game-font-title {
          margin-top: 35px;
          height: 28px;
          line-height: 28px;
          font-size: 24px;
        }

        .game-font-content {
          width: 500px;
          margin: 0 auto;
          margin-top: 22px;
          font-size: 14px;
          line-height: 22px;
          text-align: left;
        }
      }
    }

    .join-us {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        vertical-align: middle;
      }

      .join-us-content {
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .join-us-title {
        font-size: 36px;
        line-height: 36px;
        color: #fff;
      }

      .join-us-card {
        margin-top: 40px;

        a>div {
          width: 525px;
          height: 380px;
          display: inline-block;
          margin: 0 15px;
          position: relative;
          cursor: pointer;
          background-size: cover;
        }

        .join-us-card-left {
          background-image: url(../../../static/images/home/sz.jpg);
        }

        .join-us-card-right {
          background-image: url(../../../static/images/home/xz.jpg);
        }

        .join-us-card-title {
          width: 100%;
          font-size: 36px;
          color: #fff;
          line-height: 72px;
          background-color: rgba(0, 0, 0, 0.4);
          position: absolute;
          bottom: 0;
        }

        .join-us-card-title2 {
          position: absolute;
          width: 100%;
          height: 230px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.4);
          padding-top: 150px;

          .join-us-card-title2-1 {
            font-size: 36px;
            line-height: 36px;
          }

          .join-us-card-font {
            font-size: 24px;
            line-height: 24px;
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue